import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import onError from '~/modules/bugsnag/onError.js';

// Parse lodash template options into usable JS
const options = JSON.parse('{"browserApiKey":"ba168f170d2bb828ec8a66e039203097","serverApiKey":"ba168f170d2bb828ec8a66e039203097","releaseStage":"production","enabledReleaseStages":["staging","production"]}');

Bugsnag.start({
    apiKey: options.browserApiKey,
    plugins: [new BugsnagPluginVue(Vue)],
    releaseStage: options.releaseStage,
    enabledReleaseStages: options.enabledReleaseStages,
    onError
});
